module.exports = __webpack_public_path__ + "img/03c81f8.png";